import {
  FETCH_BOOKINGS,
  FETCH_BOOKINGS_SUCCESS,
  FETCH_BOOKINGS_FAILED,
  FETCH_BOOKINGS_MORE,
  UPDATE_BOOKING,
  CANCEL_BOOKING,
  CLEAR_OLD_BOOKINGS,
  BOOKINGS_PAGE_SIZE,
  USER_SIGN_OUT
} from "../store/types";

const INITIAL_STATE = {
  bookings: null,
  active: null,
  tracked: null,
  loading: false,
  loadingMore: false,
  pageLimit: BOOKINGS_PAGE_SIZE,
  hasMore: false,
  error: {
    flag: false,
    msg: null
  }
}

export const bookingslistreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_BOOKINGS:
      return {
        ...state,
        loading: state.bookings == null,
        loadingMore: false,
        error: {
          flag: false,
          msg: null
        }
      };
    case FETCH_BOOKINGS_MORE:
      return {
        ...state,
        loadingMore: true,
        error: {
          flag: false,
          msg: null
        }
      };
    case FETCH_BOOKINGS_SUCCESS:
      // CRÍTICO: Si action.payload es null (caso especial de tracked), no hacer nada
      if (!action.payload) {
        return state;
      }
      
      // CRÍTICO: Merge inteligente - preservar actualizaciones más recientes de UPDATE_BOOKING
      let mergedActive = action.payload.active ? [...action.payload.active] : [];
      
      // Si hay activeBookings existentes, mergear con los nuevos preservando actualizaciones más recientes
      if (state.active && state.active.length > 0 && mergedActive.length > 0) {
        // Crear un mapa de los bookings existentes para comparación rápida
        const existingBookingsMap = new Map();
        state.active.forEach(booking => {
          existingBookingsMap.set(booking.id, booking);
        });
        
        // Mergear: si un booking existe en ambos, preservar el que tenga el status más avanzado o más reciente
        mergedActive = mergedActive.map(newBooking => {
          const existingBooking = existingBookingsMap.get(newBooking.id);
          if (existingBooking) {
            // Priorizar el booking con status más avanzado
            const statusOrder = ['PAYMENT_PENDING', 'NEW', 'ACCEPTED', 'PICKUP_USER', 'ARRIVED', 'STARTED', 'REACHED', 'PENDING', 'PAID', 'COMPLETE'];
            const existingStatusIndex = statusOrder.indexOf(existingBooking.status);
            const newStatusIndex = statusOrder.indexOf(newBooking.status);
            
            // Si el booking existente tiene un status más avanzado, preservarlo
            if (existingStatusIndex > newStatusIndex) {
              console.log('[bookingslistreducer] 🔄 Preservando booking existente con status más avanzado:', existingBooking.id, existingBooking.status, 'vs', newBooking.status);
              return existingBooking;
            }
            // Si son iguales, Firebase gana. Mapas borrados (driverOffers, etc.) deben
            // quedar null — si solo hacemos {...existente, ...nuevo} y el nodo ya no
            // viene en el snapshot, la oferta vieja se queda pegada en la UI del pasajero.
            if (existingStatusIndex === newStatusIndex) {
              const CLEARABLE_MAPS = ['driverOffers', 'requestedDrivers', 'driverEstimates', 'selectedBid', 'preRequestedDrivers'];
              const merged = { ...existingBooking, ...newBooking };
              CLEARABLE_MAPS.forEach((key) => {
                if (!Object.prototype.hasOwnProperty.call(newBooking, key) || newBooking[key] == null) {
                  merged[key] = null;
                } else {
                  merged[key] = newBooking[key];
                }
              });
              return merged;
            }
          }
          return newBooking;
        });
        
      }
      
      // CRÍTICO: Manejar trackedBooking correctamente
      let mergedTracked = action.payload.tracked;
      
      if (state.tracked && mergedTracked) {
        // Si ambos existen, comparar IDs
        if (state.tracked.id === mergedTracked.id) {
          // Mismo booking: usar el más reciente por status (el que viene del payload es más actualizado)
          const statusOrder = ['PAYMENT_PENDING', 'NEW', 'ACCEPTED', 'PICKUP_USER', 'ARRIVED', 'STARTED', 'REACHED', 'PENDING', 'PAID', 'COMPLETE'];
          const existingStatusIndex = statusOrder.indexOf(state.tracked.status);
          const newStatusIndex = statusOrder.indexOf(mergedTracked.status);
          
          if (existingStatusIndex > newStatusIndex) {
            // El existente tiene un status más avanzado, preservarlo pero mergear datos
            console.log('[bookingslistreducer] 🔄 Preservando trackedBooking existente con status más avanzado:', state.tracked.id, state.tracked.status, 'vs', mergedTracked.status);
            mergedTracked = { ...state.tracked, ...mergedTracked };
          } else if (existingStatusIndex < newStatusIndex) {
            // El nuevo tiene un status más avanzado, usar el nuevo
            console.log('[bookingslistreducer] ✅ Actualizando trackedBooking con status más avanzado:', mergedTracked.id, state.tracked.status, '→', mergedTracked.status);
            mergedTracked = { ...state.tracked, ...mergedTracked };
          } else {
            // Mismo status, mergear datos (el nuevo puede tener datos más actualizados)
            console.log('[bookingslistreducer] 🔄 Mergeando trackedBooking con mismo status:', mergedTracked.id, mergedTracked.status);
            mergedTracked = { ...state.tracked, ...mergedTracked };
          }
        } else {
          // IDs diferentes: usar el nuevo trackedBooking del payload
          console.log('[bookingslistreducer] 🔄 trackedBooking cambió de ID:', state.tracked.id, '→', mergedTracked.id);
          console.log('[bookingslistreducer] ✅ Usando nuevo trackedBooking:', mergedTracked.id, mergedTracked.status);
        }
      } else if (state.tracked && !mergedTracked) {
        // Hay un trackedBooking existente pero no viene en el payload
        // Verificar si el booking antiguo todavía está activo y tiene un status tracked
        // REACHED y PENDING deben mantenerse tracked porque son estados activos de pago
        const trackedStatuses = ['ACCEPTED', 'PICKUP_USER', 'ARRIVED', 'STARTED', 'REACHED', 'PENDING'];
        const oldTrackedStillActive = mergedActive.find(b => b.id === state.tracked.id && 
          trackedStatuses.indexOf(b.status) != -1);
        
        if (oldTrackedStillActive) {
          // El booking antiguo todavía está activo, pero actualizar con datos de activeBookings
          console.log('[bookingslistreducer] 🔄 Preservando trackedBooking existente (todavía activo):', state.tracked.id, oldTrackedStillActive.status);
          mergedTracked = { ...state.tracked, ...oldTrackedStillActive };
        } else {
          // El booking antiguo ya no está activo, limpiarlo
          console.log('[bookingslistreducer] 🗑️ Limpiando trackedBooking antiguo (ya no está activo):', state.tracked.id);
          mergedTracked = null;
        }
      } else if (!state.tracked && mergedTracked) {
        // No hay trackedBooking existente pero viene uno nuevo
        console.log('[bookingslistreducer] ✅ Nuevo trackedBooking asignado:', mergedTracked.id, mergedTracked.status);
      }
      
      return {
        ...state,
        bookings: action.payload.bookings || state.bookings,
        active: mergedActive,
        tracked: mergedTracked,
        loading: false,
        loadingMore: false,
        pageLimit: action.payload.pageLimit != null ? action.payload.pageLimit : state.pageLimit,
        hasMore: action.payload.hasMore === true,
      };
    case FETCH_BOOKINGS_FAILED:
      return {
        ...state,
        bookings: [],
        active: [],
        tracked: null,
        loading: false,
        loadingMore: false,
        hasMore: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case UPDATE_BOOKING:
      // CRÍTICO: Actualizar activeBookings y trackedBooking inmediatamente
      const updatedBooking = action.payload;
      let newActive = state.active ? [...state.active] : [];
      let newTracked = state.tracked;
      
      // Actualizar o agregar el booking en activeBookings
      const activeIndex = newActive.findIndex(b => b.id === updatedBooking.id);
      if (activeIndex >= 0) {
        if (updatedBooking.status === 'COMPLETE' || updatedBooking.status === 'CANCELLED') {
          newActive.splice(activeIndex, 1);
        } else {
          newActive[activeIndex] = { ...newActive[activeIndex], ...updatedBooking };
        }
      } else {
        // Agregar nuevo booking si está en estados activos
        if (['PAYMENT_PENDING','NEW', 'ACCEPTED', 'PICKUP_USER', 'ARRIVED', 'STARTED', 'REACHED', 'PENDING', 'PAID'].indexOf(updatedBooking.status) != -1) {
          newActive.push(updatedBooking);
        }
      }
      
      // Actualizar trackedBooking si es conductor y el status es ACCEPTED, ARRIVED, STARTED, REACHED o PENDING
      // REACHED y PENDING deben mantenerse tracked porque son estados activos donde el conductor/cliente necesitan ver el booking para procesar el pago
      // Necesitamos obtener el usertype del store, pero por ahora actualizamos si el booking tiene driver
      const trackedStatuses = ['ACCEPTED', 'PICKUP_USER', 'ARRIVED', 'STARTED', 'REACHED', 'PENDING'];
      if (updatedBooking.driver && trackedStatuses.indexOf(updatedBooking.status) != -1) {
        newTracked = updatedBooking;
        console.log('[bookingslistreducer] 🎯 ACTUALIZANDO trackedBooking');
        console.log('[bookingslistreducer] booking.id:', updatedBooking.id);
        console.log('[bookingslistreducer] booking.status:', updatedBooking.status);
        console.log('[bookingslistreducer] booking.driver:', updatedBooking.driver);
      } else if (newTracked && newTracked.id === updatedBooking.id) {
        // Si el booking tracked cambió de status a uno no tracked, limpiar tracked
        // REACHED y PENDING deben mantenerse tracked porque son estados activos de pago
        if (!trackedStatuses.includes(updatedBooking.status)) {
          newTracked = null;
          console.log('[bookingslistreducer] 🗑️ Limpiando trackedBooking (status no tracked):', updatedBooking.status);
        } else {
          // Actualizar el booking tracked
          newTracked = { ...newTracked, ...updatedBooking };
          console.log('[bookingslistreducer] 🔄 Mergeando trackedBooking con mismo status:', updatedBooking.id, updatedBooking.status);
        }
      }
      
      console.log('[bookingslistreducer] ✅ UPDATE_BOOKING procesado');
      console.log('[bookingslistreducer] booking.id:', updatedBooking.id);
      console.log('[bookingslistreducer] booking.status:', updatedBooking.status);
      console.log('[bookingslistreducer] activeBookings actualizado:', newActive.length);
      console.log('[bookingslistreducer] trackedBooking actualizado:', newTracked ? newTracked.id : 'null');
      
      return {
        ...state,
        active: newActive,
        tracked: newTracked
      }      
    case CANCEL_BOOKING: {
      // Quitar de activos de inmediato (antes no hacía nada y la pantalla de viaje quedaba abierta).
      const cancelled = action.payload && action.payload.booking;
      if (!cancelled || !cancelled.id) return state;
      const id = cancelled.id;
      return {
        ...state,
        active: (state.active || []).filter((b) => b.id !== id),
        tracked: state.tracked && state.tracked.id === id ? null : state.tracked,
        bookings: (state.bookings || []).map((b) =>
          b.id === id ? { ...b, ...cancelled, status: 'CANCELLED' } : b
        ),
      };
    }
    case CLEAR_OLD_BOOKINGS:
      // OPTIMIZACIÓN: Limpiar bookings antiguos para liberar memoria
      const now = Date.now();
      const oneWeekAgo = now - (7 * 24 * 60 * 60 * 1000); // 7 días
      
      if (state.bookings) {
        const filteredBookings = state.bookings.filter(booking => {
          const bookingTime = booking.timestamp || booking.createdAt || 0;
          return bookingTime > oneWeekAgo;
        });
        
        return {
          ...state,
          bookings: filteredBookings.slice(0, 100) // Limitar a 100 bookings máximo
        };
      }
      return state;
    case USER_SIGN_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
};